import axios, { AxiosError, AxiosRequestConfig } from "axios";
import { shouldRedirect } from "./redirect";
import { profileStore } from "src/stores/profile-store";
import { findPermissionsByPath } from "./find-permissions";

export const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:5001";

const request = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-type": "application/json",
  },
});

const requestNoRedirect = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-type": "application/json",
  },
});

const blob = axios.create({
  baseURL: BASE_URL,
  responseType: "blob",
  headers: {},
});

const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
  // console.log("Test location : ", window.location.pathname);

  const token = localStorage.getItem("auth-token");
  const profile = profileStore.getState().profile;
  const tmpPermissions = findPermissionsByPath(window.location.pathname, profile?.menus || []);
  // console.log("Tmp Permission : ", tmpPermissions);
  // console.log("Tmp roles : ", profile?.roles);

  config.headers = {
    ...config.headers,
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(profile?.userId ? { User_id: profile.userId } : {}),
    ...(profile?.roles ? { Roles: profile.roles.toString() } : {}),
    ...(tmpPermissions ? { Permissions: tmpPermissions.toString() } : {}),
    ...(profile?.activeCompany._id ? { Active_company: profile.activeCompany._id } : {}),
  };

  return config;
};

const onRejected = (error: AxiosError): Promise<AxiosError> => {
  return Promise.reject(error);
};

const onResponseError = (error: AxiosError) => {
  const redirect = shouldRedirect(error);
  if (!redirect) return Promise.reject(error);
};

request.interceptors.request.use(onRequest, onRejected);
requestNoRedirect.interceptors.request.use(onRequest, onRejected);
blob.interceptors.request.use(onRequest, onRejected);

request.interceptors.response.use((response) => response, onResponseError);
blob.interceptors.response.use((response) => response, onResponseError);

export { blob, requestNoRedirect };
export default request;
